import { z } from 'zod';
// TODO: add 'survey' | 'banner' when those engagement flows land
// 'legacy-tour-completed' marks users who finished the retired Intercom product tour so the in the app sample tour never auto starts for them
export const INTERCOM_ACTION_TYPES = ['tour', 'legacy-tour-completed'];
export const isIntercomActionType = (value) => typeof value === 'string' &&
    INTERCOM_ACTION_TYPES.includes(value);
export const TUTORIAL_EVENT_ACTIONS = [
    'started',
    'completed',
    'dismissed'
];
export const isTutorialEventAction = (value) => typeof value === 'string' &&
    TUTORIAL_EVENT_ACTIONS.includes(value);
export const IntercomActionSchema = z.object({
    _id: z.string(),
    userId: z.string(),
    type: z.enum(INTERCOM_ACTION_TYPES),
    ref: z.string().optional(),
    payload: z.record(z.string(), z.unknown()).optional(),
    createdAt: z.date()
});
//# sourceMappingURL=intercomAction.js.map